import React, { PureComponent } from 'react';
import loadScript from 'load-script';

const SCRIPT_URL =
  'https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.6.1/iframeResizer.min.js';
const SCRIPT_INTEGRITY = 'sha256-S9PJrDx9Y/gAWrIr0moZJgyJ0wwdahYCCFfw5N8B8zQ=';
const SCRIPT_OPTIONS = {
  attrs: {
    integrity: SCRIPT_INTEGRITY,
    crossorigin: 'anonymous'
  }
};
const RESIZER_OPTIONS = {
  log: false,
  interval: 60
};

class ResizingIFrame extends PureComponent {
  constructor(props) {
    super(props);

    this.setRef = this.setRef.bind(this);
    this.attachResizer = this.attachResizer.bind(this);
    this.iframeElement = null;
  }

  componentDidMount() {
    this.attachResizer();
  }

  setRef(el) {
    this.iframeElement = el;
    this.props.innerRef && this.props.innerRef(el);
  }

  attachResizer() {
    if (!window.iFrameResize) {
      loadScript(SCRIPT_URL, SCRIPT_OPTIONS, this.attachResizer);
    } else {
      this.iframeElement.addEventListener('load', () => {
        window.iFrameResize(RESIZER_OPTIONS, this.iframeElement);
      });
    }
  }

  render() {
    const { innerRef, ...rest } = this.props;
    return (
      <iframe
        key="expanding-iframe"
        title={this.props.title}
        {...rest}
        ref={this.setRef}
      />
    );
  }
}

export default React.forwardRef((props, ref) => (
  <ResizingIFrame innerRef={ref} {...props} />
));
